var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommissionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_588_30318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2734 22.6895C10.2734 16.062 15.646 10.6895 22.2734 10.6895H33.2734C39.9009 10.6895 45.2734 16.062 45.2734 22.6895V45.6895H22.2734C15.646 45.6895 10.2734 40.3169 10.2734 33.6895V22.6895Z",
    fill: "url(#paint0_linear_588_30318)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_588_30318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4152 19.8319C35.5207 19.9391 35.6016 20.0625 35.6578 20.1943C35.7105 20.3262 35.7105 20.4703 35.7422 20.6215V24C35.7422 24.6223 35.2395 25.125 34.6172 25.125C33.9949 25.125 33.4922 24.6223 33.4922 24V23.3426L29.7867 27.0445C29.3719 27.4629 28.7074 27.4875 28.2609 27.1043L25.023 24.3551L21.8491 27.1043C21.3777 27.5086 20.6672 27.4523 20.2629 26.9813C19.8586 26.5102 19.9134 25.8 20.3849 25.3957L24.3234 22.0207C24.7453 21.6596 25.3641 21.6596 25.7859 22.0207L28.9324 24.7172L31.8996 21.75H31.2422C30.6199 21.75 30.1172 21.2462 30.1172 20.625C30.1172 20.0038 30.6199 19.5 31.2422 19.5H34.5855C34.9266 19.5 35.2078 19.6249 35.4117 19.8271L35.4152 19.8319ZM18.8672 30.1875C18.8672 29.2559 19.6227 28.5 20.5547 28.5H35.1797C36.1113 28.5 36.8672 29.2559 36.8672 30.1875V35.8125C36.8672 36.7441 36.1113 37.5 35.1797 37.5H20.5547C19.6227 37.5 18.8672 36.7441 18.8672 35.8125V30.1875ZM20.5547 35.8125H22.2422C22.2422 34.8809 21.4867 34.125 20.5547 34.125V35.8125ZM20.5547 30.1875V31.875C21.4867 31.875 22.2422 31.1191 22.2422 30.1875H20.5547ZM35.1797 34.125C34.248 34.125 33.4922 34.8809 33.4922 35.8125H35.1797V34.125ZM33.4922 30.1875C33.4922 31.1191 34.248 31.875 35.1797 31.875V30.1875H33.4922ZM27.8672 30.75C26.6262 30.75 25.6172 31.759 25.6172 33C25.6172 34.241 26.6262 35.25 27.8672 35.25C29.1082 35.25 30.1172 34.241 30.1172 33C30.1172 31.759 29.1082 30.75 27.8672 30.75Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_588_30318",
    x: 0.273438,
    y: 0.689453,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.589833 0 0 0 0 0.108333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "darken",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_588_30318"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_588_30318",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_588_30318",
    x1: 10.2734,
    y1: 28.1895,
    x2: 45.2734,
    y2: 28.1895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF924F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_588_30318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(18.8672 19.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommissionIcon);
export default __webpack_public_path__ + "static/media/commission-icon.e553ec06a5be05134bfcf078d7405270.svg";
export { ForwardRef as ReactComponent };